import ERROR_CODES from 'data/errorCodes';

// Transforms GraphQL messages into a more usable format for Formik.
export default (error) => {
  const errors = {};

  if(error && error.graphQLErrors) {
    error.graphQLErrors.forEach(err => {
      if (err.backendName === ERROR_CODES.CODE_MISMATCH) {
        errors[err.backendName] = err.message;
      }
      else if (err.backendName === ERROR_CODES.INVALID_MIGRATION_PASSWORD) {
        errors[err.backendName] = err.message;
      }
      else {
        errors[err.code] = err.message;
      }

      console.error(err);
    });
  }

  return errors;
};
